import { render, staticRenderFns } from "./BotoesEdicao.vue?vue&type=template&id=334c0829&"
import script from "./BotoesEdicao.vue?vue&type=script&lang=js&"
export * from "./BotoesEdicao.vue?vue&type=script&lang=js&"
import style0 from "./BotoesEdicao.vue?vue&type=style&index=0&id=334c0829&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports